import { GoodsForCheckPlanNumModel } from "./vo/goods-for-check-plan-num.model";
import { PlanNumSearchParamsModel } from "./vo/plan-num-search-params.model";

export class KYMW7500Model {
  static readonly PROGRESS_WORK_NUM_FIXED_PLAN = 7;
  private readonly blankOption = { code: '', name: '' };

  // 検索条件の選択肢
  public orderList: { orderCode: string, catalogId: string; }[] = [];
  public buyerList: { code: string, name: string; }[] = [];
  public mediumTypeList: { mediumType: string, mediumName: string; }[] = [];
  public classCodeList: { code: string, name: string; }[] = [];
  public featureList: { code: string, name: string; }[] = [];
  public readonly boundaryNumList = this.createBoundaryNumList();

  // 検索パラメータ
  public searchParams = new PlanNumSearchParamsModel();
  // 表示している商品一覧を検索したときの検索パラメータ
  public savedSearchParams = new PlanNumSearchParamsModel();

  // 商品一覧
  public goodsList: GoodsForCheckPlanNumModel[] = [];
  public isHeaderChecked = false;
  public checkedPCodes: string[] = [];
  public isEdited = false;

  private createBoundaryNumList() {
    const boundaryNumOptions = [...Array(6)].map(((_, i) => ({ code: (i * 10).toString(), name: `${i * 10}%` })));
    return [{ ...this.blankOption }, ...boundaryNumOptions];
  }

  public isOrderCodeValid() {
    return !!this.searchParams.orderCode && !!this.searchParams.catalogId;
  }

  /**
   * 受注コードと企画回以外の選択肢と選択をクリア
   */
  public clearLists() {
    this.clearMediumType();
    this.clearClassCode();
    this.clearFeature();
    this.searchParams.buyerCode = '';
    this.searchParams.folio = '';
    this.searchParams.checkFlag = false;
    this.searchParams.progressWorkNum = '',
    this.clearMiddleClassCode();
    this.clearBoundaryNum();
    this.clearBoundaryNumDetail();
  }
  // 媒体クリア
  public clearMediumType() {
    this.searchParams.mediumType = '';
  }
  // 部門クリア
  public clearClassCode() {
    this.classCodeList = [];
    this.searchParams.classCode = '';
  }
  // 特集クリア
  public clearFeature() {
    this.featureList = [];
    this.searchParams.featureCode = '';
  }
  // 中分類クリア
  public clearMiddleClassCode() {
    this.searchParams.middleClassCode = '';
  }
  // 閾値（コンボボックス）クリア
  public clearBoundaryNum() {
    this.searchParams.boundaryNum = '';
  }
  // 閾値（テキスト）クリア
  public clearBoundaryNumDetail() {
    this.searchParams.boundaryNumDetail = '';
  }
  // 商品一覧クリア
  public clearGoodsList() {
    this.goodsList = [];
    this.isHeaderChecked = false;
    this.checkedPCodes = [];
    this.isEdited = false;
  }

  // 編集チェック
  public setIsEdited(isEdited: boolean) {
    this.isEdited = isEdited;
  }

  // 検索条件保存
  public saveSearchParams() {
    this.savedSearchParams = this.searchParams.copy();
  }

  public initCheckedPCodes() {
    this.checkedPCodes = [...this.goodsList.filter(goods => goods.checkFlag).map(goods => goods.pCode)];
  }

  // 行チェックボックス処理
  public isRowCheckBoxDisabled(pCode: string) {
    return this.isOrderCodeFixed() || (this.goodsList.find(goods => goods.pCode === pCode)?.checkFlag ?? false);
  }

  public isOrderCodeFixed() {
    return Number(this.savedSearchParams.progressWorkNum) >= KYMW7500Model.PROGRESS_WORK_NUM_FIXED_PLAN;
  }

  public isChecked(pCode: string) {
    return this.checkedPCodes.includes(pCode);
  }

  public updateCheckedPCodes(pCode: string) {
    if (this.isChecked(pCode)) {
      this.checkedPCodes = this.checkedPCodes.filter(checkedPCode => checkedPCode !== pCode);
    } else {
      this.checkedPCodes = [...this.checkedPCodes, pCode];
    }
  }

  // ヘッダーチェックボックス処理
  public updateIsHeaderChecked() {
    this.isHeaderChecked = this.checkedPCodes.length === this.goodsList.length;
  }

  // ヘッダーのチェックボックスの非活性制御
  public isHeaderCheckboxDisabled() {
    return this.isOrderCodeFixed() || this.goodsList.every(goods => goods.checkFlag);
  }

  // 全てチェックする処理
  public checkAllGoods() {
    this.checkedPCodes = this.goodsList.map(goods => goods.pCode);
    this.isHeaderChecked = true;
  }
  // 全てチェック解除する処理
  public clearAllGoods() {
    this.initCheckedPCodes();
    this.isHeaderChecked = false;
  }

  // ヘッダーのチェックボックスのチェック処理
  public initHeaderChecked() {
    this.isHeaderChecked = this.checkedPCodes.length === this.goodsList.length;
  }

  // 設定ボタンの非活性制御
  public isRegistrationDisabled() {
    return this.goodsList.length === 0 || this.isOrderCodeFixed();
  }
}